<template>
    <div class="container">
        <h2 class="title"> {{ $t("home.last_news.title") }}</h2>
        <router-link to="/last_news" class="view-all"> {{ $t("home.last_news.show_all") }}</router-link>

        <!-- Swiper Slider -->
        <swiper :slides-per-view="1" :space-between="20" :loop="true" @slideChange="updatePagination"
            :autoplay="{ delay: 5000, disableOnInteraction: false }" class="news-slider">
            <swiper-slide v-for="(item, index) in news" :key="index">
                <HorizontalCard :item="item" />
            </swiper-slide>
            <DotsPagination :currentSlide="currentSlide" :totalSlides="news.length" />

        </swiper>

        <!-- Pass Pagination Data to DotsPagination -->
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import DotsPagination from "../Pagination/DotsPagination.vue";
import HorizontalCard from "../News/HorizontalCard.vue";

export default {
    props: ["news"],
    components: {
        Swiper,
        SwiperSlide,
        HorizontalCard,
        DotsPagination,
    },
    data() {
        return {
            currentSlide: 0, // Track active slide index
        };
    },
    methods: {
        updatePagination(swiper) {
            this.currentSlide = swiper.realIndex;
        },
    }
};
</script>

<style scoped>
.container {
    margin-top: 40px;
}

.title {
    font-size: 36px;
    font-weight: 500;
    display: inline;
}

.view-all {
    font-size: 20px;
    font-weight: 500;
    color: #BF9F35;
    text-decoration: none;
    float: inline-end;
    text-decoration: underline;
    cursor: pointer;
}

.news-slider {
    margin-top: 20px;
}
</style>